export default {
  nodes: [
    {
      id: '1',
      name: '销售专员',
      conf: [],
    },
    {
      id: '2',
      name: '销售主管',
      conf: [],
    },
    {
      id: '3',
      name: '销售经理',
      conf: [],
    },
    {
      id: '4',
      name: '销售部经理',
      conf: [],
    },
    {
      id: '5',
      name: '行业销售经理',
      conf: [],
    },
    {
      id: '6',
      name: '区域销售经理',
      conf: [],
    },
    {
      id: '7',
      name: '销售总监',
      conf: [],
    },

  ],
  edges: [
    {
      source: '1',
      target: '2',
    },
    {
      source: '2',
      target: '3',
    },
    {
      source: '3',
      target: '4',
    },
    {
      source: '3',
      target: '5',
    },
    {
      source: '3',
      target: '6',
    },
    {
      source: '4',
      target: '7',
    },
    {
      source: '5',
      target: '7',
    },
    {
      source: '6',
      target: '7',
    }

  ]
}